module.exports = __webpack_public_path__ + "media/123.e3a7b930.mp4";